import { formatTime } from "@hudson/ui/lib/date_fns_locale";
import { formatCurrency } from "@utils/i18n";
import RepriceLoader from "../RepriceLoader";
import useContent from "@lib/use_content";
import DebugFare from "@components/Debug/Fare";
import SubfarePopup from "@components/Subfares/Popup";
import SubfareSummary from "@components/Subfares/Summary";

interface ServiceParams {
  className?: string;
  currency?: string;
  hideSubFares?: boolean;
  isRepricing?: boolean;
  service: be.Service;
  showPickupTime?: boolean;
  timeFormat?: be.TimeFormat;
  vertical?: boolean;
}

function Service({
  className = "",
  currency,
  hideSubFares,
  isRepricing,
  service,
  showPickupTime,
  timeFormat,
  vertical,
}: ServiceParams): JSX.Element | null {
  const { data } = useContent(["beRessummaryPickupAtLabel"]);

  return (
    <>
      <div
        className={`${className} flex flex-wrap items-center gap-x-3 justify-center ${
          vertical ? "flex-col-reverse xs:flex-row" : "flex-col-reverse min-w-40 gap-y-3"
        }`}
      >
        {service.hideFareMode == "never" &&
        service.fareDisplay &&
        Number(service.fareDisplay) > 0 ? (
          <dl className="relative">
            <div className="flex items-center justify-between border-gray-200">
              <dd className="font-number text-xl font-medium text-gray-900">
                {isRepricing ? (
                  <RepriceLoader>{formatCurrency(service.fareDisplay, currency)}</RepriceLoader>
                ) : (
                  <div className="flex">
                    {formatCurrency(service.fareDisplay, currency)}
                    {!hideSubFares && service.hideSubfareMode == "never" && (
                      <SubfarePopup subfares={service.webSubfares} />
                    )}
                    <DebugFare
                      label="?"
                      components={service.fareComponents}
                      className="inline-block ml-2"
                    />
                  </div>
                )}
              </dd>
            </div>
          </dl>
        ) : null}

        {Number(service.fareDisplay) > 0 && vertical && service.hideFareMode == "never" && (
          <svg
            viewBox="0 0 2 2"
            className="hidden xs:block h-1 w-1 flex-none fill-gray-400"
            aria-hidden="true"
          >
            <circle cx="1" cy="1" r="1"></circle>
          </svg>
        )}

        <div>
          <p className="text-lg text-gray-500 font-light">{service.name}</p>
          {showPickupTime && service.selectedTime?.pickupTime && (
            <p className="test-base text-gray-500 font-bold text-[--primary-color]">
              {data?.content.beRessummaryPickupAtLabel}&nbsp;
              {formatTime(service.selectedTime?.pickupTime, timeFormat)}
            </p>
          )}
        </div>
      </div>
      {service.hideFareMode == "never" && !hideSubFares && (
        <SubfareSummary subfares={service.webSubfares} />
      )}
    </>
  );
}

export default Service;
